import React, { FC } from "react";

// UI components
import { Flex } from "../Flex/Flex";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import { ChakraStyledOptions } from "@chakra-ui/react";

// i18n
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

const flexDirections = {
  horizontal: "row",
  vertical: "column",
};

const dividerWidths = {
  horizontal: "25%",
  vertical: "2px",
};

const dividerHeights = {
  horizontal: "2px",
  vertical: "25%",
};

export const Or: FC<ChakraStyledOptions> = ({
  orientation = "horizontal",
  ...props
}) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection={flexDirections[orientation]}
      height="100%"
      width="100%"
      {...props}
    >
      <Box
        width={dividerWidths[orientation]}
        height={dividerHeights[orientation]}
        backgroundColor="sand.400"
      />
      <Text
        textTransform="uppercase"
        color="sand.600"
        fontWeight="bold"
        padding="8"
      >
        <FormattedMessage {...messages.or} />
      </Text>
      <Box
        width={dividerWidths[orientation]}
        height={dividerHeights[orientation]}
        backgroundColor="sand.400"
      />
    </Flex>
  );
};
